<template>
    <div>

        <div class="columns is-multiline">
            <div class="column is-two-quarters">
                <b-field label="Buscar">
                    <b-input
                    v-model="searchQ"
                    type="search"
                    icon="search"
                    placeholder="Buscar nombre o codigo"
                    @input="updateSearchParams">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-quarter">
                <b-field label="Categoria">
                    <b-select v-model="categoryQ"
                    @input="updateSearchParams"
                    expanded>
                        <option value="">------</option>
                        <option v-for="cat in categoryList" :key="cat.id" :value="cat">
                            {{cat.title}}
                        </option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-one-quarter">
                <b-field label="Subcategoria">
                    <b-select v-model="subcategoryQ"
                    @input="updateSearchParams"
                    expanded>
                        <option value="">------</option>
                        <option v-for="sub in subcategoriesForSearch" :key="sub.id" :value="sub">
                            {{sub.title}}
                        </option>
                    </b-select>
                </b-field>
            </div>
        </div>

        <b-table
        :data="items.length ? items : []"
        :loading="loadingList"
        :narrowed="true"
        :striped="false"
        :bordered="false"
        :mobile-cards="false"
        >
            <template slot-scope="props">
                <b-table-column width="100px">
                    <img width="80px" class="image" :src="props.row.getImage" alt="product-image">
                </b-table-column>
                <b-table-column>
                    <p><strong>{{ props.row.title }}</strong></p>
                </b-table-column>
                <b-table-column >
                    <p class=" tag is-success">{{props.row.currencySymbol}}{{props.row.price}}</p>
                </b-table-column>
                <b-table-column>
                    <b-button
                    type="is-info"
                    outlined
                    rounded
                    @click="fetchProdDetail(props.row.slug)">
                        <b-icon icon="plus" size="is-small"></b-icon>
                        Agregar al pedido
                    </b-button>
                </b-table-column>
            </template>

             <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <img style="max-width:250px;" :src="notFound" alt="not-found">
                        </p>
                        <p>No encontramos productos para ti...</p>
                    </div>
                </section>
            </template>

        </b-table>
        <ProductDetailForm
        :prodDetailModal="prodDetailModal"
        :product="selectedProdDetailObj"
        :saveButtonDisabled="detailSaveButtonDisabled"
        :prodDetailLoading="prodDetailLoading"
        :createCartItemUrl="createCartItemUrl"
        @addedItemToCart="addedItemToCartCatch"
        />
    </div>
</template>

<script>
import { getHandler } from '../../../../services/http'
import ProductDetailForm from './ProductDetailForm'
export default {
    components:{
        ProductDetailForm
    },
    props:{
        loadingList:{
            type: Boolean,
            default: false
        },
        items:{
            type: Array,
            default: new Array([])
        },
        prodDetailUrl:{
            type:String,
            default:""
        },
        createCartItemUrl:{
            type:String,
            default:""
        },
        categoryList:{
            type: Array,
            default: new Array([])
        },
        subcategoryList:{
            type: Array,
            default: new Array([])
        },
        notFound:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            prodDetailModal:false,
            selectedProdDetailId:0,
            selectedProdDetailObj:{},
            prodDetailLoading:false,
            searchQ:"",
            categoryQ:"",
            subcategoryQ:"",
        }
    },
    computed:{
        subcategoriesForSearch(){
            var subs = this.subcategoryList.filter((element)=>{
                return element.category == this.categoryQ.id
            })
            return subs
        },

    },
    methods:{
        async fetchProdDetail(slug){
            this.prodDetailModal = false
            this.prodDetailModal = true
            this.selectedProdDetailSlug=slug
            this.prodDetailLoading=true
            var url = this.prodDetailUrl.replace('0000', slug)
            var response = await getHandler(url, {error:false, success:false})
            this.selectedProdDetailObj = response
            this.prodDetailLoading=false
            this.detailSaveButtonDisabled = false
            if (this.selectedProdDetailObj.attributes.length){
                this.detailSaveButtonDisabled = true
            }
        },
        addedItemToCartCatch(){
            this.$emit("addedItemToCart")
        },
        updateSearchParams(){
            this.prodDetailModal = false
            if (!this.categoryQ.length){
                this.subcategoryQ = ""
            }
            var data = {
                categoryQ:this.categoryQ,
                subcategoryQ:this.subcategoryQ,
                searchQ:this.searchQ
            }
            this.$emit("refreshProdList", data)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>